import React from "react"
import PropTypes from "prop-types"
import { Flex } from "antd"
import { useMediaQuery } from "react-responsive"
import { useTranslation } from "react-i18next"
import { useDevice } from "hooks/useDevice"
import WidgetSheet from "../../WidgetSheet"
import styles from "./BookingPanel.module.css"

// The "Real-Time Availability" frame around a booking panel's sections and its actions (Add to
// Cart, the payment note). From 992px it sits beside the details; below that it is a sheet opened
// from the page's price bar (Figma 7410:111837 tablet, from the right; 6058:142637 phone, from the
// bottom) with the actions pinned at its foot.
const PanelFrame = ({ isSheetOpen, onSheetClose, actions, children }) => {
  const { t } = useTranslation()
  const isCompact = useMediaQuery({ maxWidth: 991 })
  const { isMobile } = useDevice()
  const title = t("booking_widget.experience.panel_title")

  if (isCompact) {
    return (
      <WidgetSheet
        isOpen={isSheetOpen}
        onClose={onSheetClose}
        title={title}
        placement={isMobile ? "bottom" : "right"}
        footer={
          <Flex vertical gap={12}>
            {actions}
          </Flex>
        }
      >
        <Flex vertical gap={8} className={styles.sheetSections}>
          {children}
        </Flex>
      </WidgetSheet>
    )
  }

  return (
    <Flex vertical gap={16} className={styles.panel}>
      <h2 className={styles.panelTitle}>{title}</h2>
      {children}
      <Flex vertical gap={8}>
        {actions}
      </Flex>
    </Flex>
  )
}

PanelFrame.propTypes = {
  isSheetOpen: PropTypes.bool,
  onSheetClose: PropTypes.func,
  actions: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired
}

PanelFrame.defaultProps = {
  isSheetOpen: false,
  onSheetClose: () => {}
}

export default PanelFrame
